import Hls, { HlsConfig } from 'hls.js'

export function CreateHls(
  src: string,
  media: HTMLVideoElement,
  config = {} as Partial<HlsConfig>
) {
  const hls = new Hls(config)
  hls.loadSource(src)
  hls.attachMedia(media)
  return hls
}
